
import React, { useEffect } from 'react';
import { Link } from "react-router-dom";

const ContactUs = () => {
    const THEME_COLOR = '#065f46';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '100px' }}>
            
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        {/* Main Contact Card */}
                        <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: '2rem' }}>
                            <div className="row g-0">
                                
                                {/* Left Side: Info */}
                                <div className="col-md-5 text-white p-4 p-lg-5 d-flex flex-column justify-content-center" style={{ backgroundColor: THEME_COLOR }}>
                                    <h2 className="fw-bold mb-4">Contact Us</h2>
                                    <p className="opacity-75 mb-5">Have a question or need assistance? Our team is here to help you define your unique look.</p>
                                    
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="rounded-circle bg-white bg-opacity-25 p-3 me-3">
                                            <i className="ri-mail-line fs-4"></i>
                                        </div>
                                        <div>
                                            <p className="small mb-0 opacity-75">Email us at</p>
                                            <h6 className="mb-0">info@munnyfinds.com</h6>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center mb-4">
                                        <div className="rounded-circle bg-white bg-opacity-25 p-3 me-3">
                                            <i className="ri-phone-line fs-4"></i>
                                        </div>
                                        <div>
                                            <p className="small mb-0 opacity-75">Call Support</p>
                                            <h6 className="mb-0">+234 800 MUNNY FIND</h6>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <div className="rounded-circle bg-white bg-opacity-25 p-3 me-3">
                                            <i className="ri-map-pin-line fs-4"></i>
                                        </div>
                                        <div>
                                            <p className="small mb-0 opacity-75">Our Location</p>
                                            <h6 className="mb-0">Victoria Island, Lagos, Nigeria</h6>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Side: Engagement Message */}
                                <div className="col-md-7 bg-white p-4 p-lg-5 d-flex flex-column justify-content-center">
                                    <div className="badge rounded-pill mb-3 px-3 py-2 align-self-start" style={{ backgroundColor: '#d1fae5', color: THEME_COLOR, fontSize: '0.75rem', fontWeight: '800' }}>
                                        GET IN TOUCH
                                    </div>
                                    <h3 className="fw-bold mb-4" style={{ color: '#064e3b' }}>We'd love to hear from you</h3>
                                    <p className="text-secondary mb-4" style={{ lineHeight: '1.8' }}>
                                        Whether you are a salon owner looking to join our partner network or a customer seeking the perfect beauty professional, 
                                        we are ready to assist.
                                    </p>
                                    
                                    <div className="p-4 rounded-4" style={{ backgroundColor: '#f9fafb', border: '1px dashed #e5e7eb' }}>
                                        <h6 className="fw-bold text-dark mb-2">Business Hours</h6>
                                        <p className="small text-muted mb-0">Monday — Friday: 9:00 AM - 8:00 PM</p>
                                        <p className="small text-muted mb-0">Saturday: 10:00 AM - 8:00 PM</p>
                                        <p className="small text-muted mb-0">Sunday: 9:00 AM - 9:00 PM</p>
                                    </div>

                                    <div className="mt-5">
                                        <p className="small fw-bold text-uppercase text-muted mb-3" style={{ letterSpacing: '1px' }}>Follow our journey</p>
                                        <div className="d-flex gap-3 fs-3">
                                            <i className="ri-facebook-box-fill" style={{ color: THEME_COLOR }}></i>
                                            <i className="ri-twitter-x-line" style={{ color: THEME_COLOR }}></i>
                                            <i className="ri-instagram-line" style={{ color: THEME_COLOR }}></i>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= FOOTER (REPLACED FROM HOME.JSX) ================= */}
            <footer className="bg-white pt-5 pb-4 mt-5 border-top border-light position-relative">
                <div className="container">
                    <div className="row align-items-center mb-4">
                        <div className="col-md-6 mb-3 mb-md-0">
                            <span className="text-dark fs-5 fw-medium">Payment methods:</span>
                            <div className="d-flex gap-3 mt-3 align-items-center">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" style={{ height: '22px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" style={{ height: '22px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="MasterCard" style={{ height: '25px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg" alt="Amex" style={{ height: '22px' }} />
                            </div>
                        </div>
                        <div className="col-md-6 text-md-end">
                            <span className="text-dark fs-5 fw-medium">Keep in touch</span>
                            <div className="d-flex gap-3 justify-content-md-end mt-3 fs-3 text-secondary">
                                <i className="ri-facebook-box-fill"></i>
                                <i className="ri-twitter-x-line"></i>
                                <i className="ri-instagram-line"></i>
                                <i className="ri-threads-line"></i>
                            </div>
                        </div>
                    </div>

                    <hr className="my-5" style={{ borderTop: '1px dotted #dee2e6' }} />

                    <div className="text-center">
                        <div className="d-flex flex-wrap justify-content-center gap-4 mb-4">
                            <a href="/Frequently-Asked-Questions.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">FAQ</a>
                            <a href="/Partner-Terms.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Partner Terms</a>
                            <a href="/Terms-and-Condition.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Terms & Conditions</a>
                            <a href="/Partner-Terms.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Terms of use</a>
                            <a href="/Privacy-Policy.pdf" target="_blank" rel="noopener noreferrer" className="text-decoration-none fw-medium text-dark">Privacy Policy</a>
                        </div>
                        <p className="small text-muted mb-0">Copyright © 2026 <span className="fw-bold text-dark">Munny Finds</span>. All Rights Reserved</p>
                    </div>

                    <button 
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
                        className="btn position-absolute bottom-0 end-0 m-4 rounded-circle d-flex align-items-center justify-content-center shadow-sm" 
                        style={{ backgroundColor: '#86efac', width: '50px', height: '50px', border: 'none', color: 'white' }}
                    >
                        <i className="ri-arrow-up-line fs-4"></i>
                    </button>
                </div>
            </footer>
        </div>
    );
};

export default ContactUs;